import { ReactNode } from 'react';
import { EmptyData } from './EmptyData';
import { InsightPanel } from './InsightPanel';
import { InsightType } from '../domain';

type InsightPanelPlaceholderProps = {
  type?: InsightType;
  title: string | ReactNode;
  colSpan: number;
};

export const InsightPanelPlaceholder = ({ type, title, colSpan }: InsightPanelPlaceholderProps) => {
  return (
    <InsightPanel colSpan={colSpan} type={type} title={title}>
      <EmptyData type={type} />
    </InsightPanel>
  );
};
